import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import SpacePath from "components/SpacePath";
import { BlueprintIntegrationAttachment } from "types/generated";

const IntegrationUsedByTableSpaceCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<BlueprintIntegrationAttachment>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath
        spaceId={blueprint.blueprintSpaceDetails.id}
        fallbackName={blueprint.blueprintSpaceDetails.name}
      />
    </TableSimpleCell>
  );
};

export default IntegrationUsedByTableSpaceCell;
